import {
    ButtonChooseTemplate as _ButtonChooseTemplate,
    useAiContext,
} from '@/biz/ai'

import {ButtonImportModel as _ButtonImportModel} from '@/biz/ai/chat'

export default function ButtonChooseTemplate(props) {
    const ai = useAiContext()
    const {layoutTypeCode: uiLayoutType} = ai.bizData

    return (
        <_ButtonChooseTemplate
            extra={{uiLayoutType}}
            {...props}
        />
    )
}
